/** @jsx jsx */

import { Fragment as _, useEffect, useRef, useLayoutEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { values } from 'styles/variables';
import { connect } from 'react-redux';
import getBlockById from 'services/apiHelpers/getBlockById';
import { createContext } from 'react';
import { Flexbox } from '@chameleoncreator/creator-ui';

import getStore from 'services/getStore';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';

import isIE from 'services/isIE';
import ie11VerticalFlexCenterFix from 'services/ie11VerticalFlexCenterFix';

import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import Wrapper from './Wrapper';
import { useSelector } from 'react-redux';
import HiddenBackButton from './HiddenBackButton';

import getAllInteractions from 'services/apiHelpers/getAllInteractions';
import Background from './Background';
import next from './next';
import updateReadOnlyText from 'services/updateReadOnlyText';
import pubSub from 'services/pubSub';
import { createSelector } from 'reselect';

const store = getStore();

const { headerHeight } = values;

let hasFocus: boolean;

const renderCount = {};

// this is all for testing which element has focus
// set to false to disable ( and we'll delete when we update final for prod )
const whatIsTheActiveElement = false;
//
if (whatIsTheActiveElement) {
  const ACTIVE_ELEMENT_MARKER = document.createElement('div');
  ACTIVE_ELEMENT_MARKER.style.position = 'fixed';
  ACTIVE_ELEMENT_MARKER.style.border = '2px solid lime';
  document.body.appendChild(ACTIVE_ELEMENT_MARKER);

  setInterval(() => {
    const { activeElement } = document as any;

    if (!activeElement) {
      return;
    }

    const { top, left, width, height } = activeElement.getBoundingClientRect();
    ACTIVE_ELEMENT_MARKER.style.pointerEvents = 'none';
    ACTIVE_ELEMENT_MARKER.style.top = `${top}px`;
    ACTIVE_ELEMENT_MARKER.style.left = `${left}px`;
    ACTIVE_ELEMENT_MARKER.style.width = `${width}px`;
    ACTIVE_ELEMENT_MARKER.style.height = `${height}px`;
    ACTIVE_ELEMENT_MARKER.style.zIndex = '2147483647';
  }, 100);
}

export const InteractionContext = createContext<any>(undefined);

const getInteractionsOpen = createSelector(
  (state: any) => state.interactionsOpen,
  interactionsOpen => interactionsOpen
);

const Container = (props: any) => {
  const { id, focusedNodeId, name, style, children, lockDown } = props;

  let {
    sId,
    background = undefined,
    backgroundImage = undefined,
    backgroundImageOpacity = 100,
    src = undefined,
    textColor = style.foreground,
  } = getBlockById(id).props as any;

  let interactionsOpen = useSelector(getInteractionsOpen);
  const isOpen = props.isOpen || interactionsOpen.includes(id);

  // dirty gotta try and cover for legacy backgroundImage
  if (src) {
    backgroundImage = `url('${src}') center / cover no-repeat`;
  }

  const section: any = useRef(null);
  const selected = id === focusedNodeId;

  const parsedTextColor =
    textColor ||
    getBlockById(getCurrentTopic()!.id)!.props!.textColor ||
    (store.getState().theme as any).textColor ||
    '';
  const contentContainer = useRef(null);

  useLayoutEffect(() => {
    if (!section.current) {
      section.current = document.querySelector(`#i${id}`);
    }

    !window.dev() && updateReadOnlyText(section.current);
  }, [parsedTextColor]);

  useEffect(() => {
    const pS = pubSub.subscribe('FOCUS_NODE', $ => {
      console.log('does this ever get called ?', $);
      setCurrentBlock($);
    });

    return () => {
      pS();
    };
  }, []);

  useEffect(() => {
    if (selected) {
      hasFocus = true;
    }

    return () => {
      hasFocus = false;
    };
  }, []);

  useEffect(() => {
    const buttons = Array.from(section.current.querySelectorAll('button'));
    const continueBtn = buttons[buttons.length - 1] as HTMLElement;
    //

    if (!continueBtn) {
      return;
    }

    const onKeyDown = (e: any) => {
      const { key, shiftKey } = e;

      if (shiftKey) {
        return;
      }

      if (key === 'Tab') {
        // console.log('ignore Shift + Tab !!! set focus back to section');

        section.current.focus();

        e.preventDefault();
        // return;
      }
    };

    continueBtn.addEventListener('keydown', onKeyDown);

    return () => {
      continueBtn.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  useEffect(() => {
    if (!lockDown) {
      return;
    }
  });

  let isLocked = lockDown;

  // since the background gets set on the style on creation
  // kill it if we have a ' local ' background color
  // goal would be to remove it from the factory. but it's legacy from wizard
  // WINDING on down. . .
  const overideStyleBackground = props.hasOwnProperty('background')
    ? {
        background: background || '',
      }
    : {};

  const getSectionLabel = () => {
    return '';

    return `Section ${getAllInteractions().findIndex((i: any) => i === id) +
      1}`;
  };

  if (!renderCount[id]) {
    renderCount[id] = 0;
  }

  return (
    <InteractionContext.Provider
      value={{ id, next: next(sId, id), isLocked, children }}
    >
      <Flexbox
        as="section"
        id={`i${id}`}
        css={css`
          ${!isOpen &&
            `
          display: none;
         
      `}

          .chameleon-text {
            ${parsedTextColor && `color: ${parsedTextColor};`}
          }

          li > span {
            ${parsedTextColor && `color: ${parsedTextColor};`}
          }
        `}
        style={{
          position: 'relative',
          overflowX: 'hidden',
          ...{
            ...style,
            ...overideStyleBackground,
          },
        }}
        py={!isIE() ? 4 : 0}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight={'100vh'}
        width={['100%']}
        paddingTop={70}
        data-section
        data-section-text-color={parsedTextColor}
        aria-label={
          props.sectionLabel
          // ||
          // getSectionLabel() ||
          // name ||
          // props['aria-label']
        }
        // role="main"
        tabIndex={-1}
      >
        <Background
          // key={background && background.includes('url') && background}
          // background={background}
          key={backgroundImage}
          background={backgroundImage}
          backgroundImageOpacity={backgroundImageOpacity}
        />

        <HiddenBackButton id={id} />

        {!isIE() ? (
          <Flexbox
            ref={contentContainer}
            position="relative"
            flexDirection="column"
            justifyContent="center"
            // height="auto"
            width={['100%']}
            maxWidth={['100%', null, '1100px']}
          >
            {children}
          </Flexbox>
        ) : (
          <div
            ref={contentContainer}
            css={css`
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              max-width: 1100px;
              min-height: calc(100vh - 70px);

              ${ie11VerticalFlexCenterFix(
                `height: ${
                  window.dev()
                    ? `calc(100% - ${headerHeight}px)`
                    : 'calc(100vh - 70px)'
                }`
              )}
            `}
          >
            <div
              css={css`
                position: relative;
                display: flex;
                flex-direction: column;
                width: 100%;
              `}
            >
              {children}
            </div>
          </div>
        )}

        {window.dev() && <Wrapper id={id} focusedNodeId={focusedNodeId} />}
      </Flexbox>
    </InteractionContext.Provider>
  );
};

// export default Container;

export default connect(
  ({ focusedNodeId }: { focusedNodeId: string | number }) => ({
    focusedNodeId,
    // forceUpdate: Math.random(),
  })
)(Container);
